import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import './CoinsList.scss'

const CoinsList = ({ coins, onCoinSelect, inPopover }) => {
   const { isDarkTheme } = useSelector(state => state.theme)

   return (
      <div
         className={clsx(
            'CoinsList',
            inPopover && 'CoinsList--popover',
            isDarkTheme && 'CoinsList--dark'
         )}
      >
         {coins.map(coin => (
            <div
               className="CoinsList__coin"
               key={coin.id}
               onClick={() => onCoinSelect(coin)}
            >
               <img
                  className="CoinsList__coin-image"
                  src={coin.image}
                  alt={coin.name}
                  loading="lazy"
               />
               <span className="CoinsList__coin-unit">{coin.unit}</span>
               <span className="CoinsList__coin-name">{coin.name}</span>
            </div>
         ))}
      </div>
   )
}

export default CoinsList
